import React from 'react';
import { Link } from 'react-router-dom';
import Disclaimer from '../components/Disclaimer';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowLeft, Newspaper, Calendar, ArrowRight, Filter } from 'lucide-react';

const NewsPage = () => {
  const news = [
    {
      id: 1,
      title: 'Nouveaux bonus disponibles pour décembre 2025',
      excerpt: 'Découvrez les dernières offres promotionnelles des opérateurs agréés pour maximiser vos gains en cette fin d\'année.',
      date: '05.12.2025',
      slug: 'nouveaux-bonus-decembre-2025',
      image: '/images/abhay-siby-mathew-HCi8OFNa_F8-unsplash.webp',
    },
    {
      id: 2,
      title: 'Guide complet : stratégies de paris sur le football',
      excerpt: 'Apprenez les techniques avancées pour analyser les matchs et améliorer votre taux de réussite sur les paris football.',
      date: '03.12.2025',
      slug: 'strategies-paris-football',
      image: '/images/danny-lines-7yfKErZo5ro-unsplash.webp',
    },
    {
      id: 3,
      title: 'Comparatif des meilleures cotes du marché',
      excerpt: 'Notre analyse mensuelle révèle quels opérateurs proposent les cotes les plus avantageuses sur les principaux événements sportifs.',
      date: '01.12.2025',
      slug: 'comparatif-cotes-decembre',
      image: '/images/akshay-gill-qk03WPpOS-Q-unsplash.webp',
    },
    {
      id: 4,
      title: 'Évolution du marché des paris en ligne en France en 2025',
      excerpt: 'Analyse approfondie des tendances, des chiffres clés et des évolutions réglementaires qui façonnent l\'industrie des paris sportifs français.',
      date: '28.11.2025',
      slug: 'evolution-marche-paris-ligne-france-2025',
      image: '/images/dmitry-osipenko-v37kr3k_G3M-unsplash.webp',
    },
    {
      id: 5,
      title: 'Nouveaux opérateurs agréés par l\'ANJ : opportunités et comparaisons',
      excerpt: 'Découvrez les nouveaux acteurs du marché français et comparez leurs offres avec les opérateurs établis pour faire le meilleur choix.',
      date: '25.11.2025',
      slug: 'nouveaux-operateurs-agrees-anj',
      image: '/images/kirill-zharkiy-ItKtQ-OaIzQ-unsplash.webp',
    },
    {
      id: 6,
      title: 'Parier sur le tennis : tendances et opportunités de gains',
      excerpt: 'Le tennis offre de nombreuses opportunités de paris tout au long de l\'année. Découvrez les stratégies gagnantes et les tournois à suivre.',
      date: '22.11.2025',
      slug: 'paris-tennis-tendances-opportunites',
      image: '/images/logan-weaver-lgnwvr-XcBPc0Q_2h8-unsplash.webp',
    },
    {
      id: 7,
      title: 'Sécurité et protection des données sur les sites de paris',
      excerpt: 'Comment les opérateurs agréés protègent vos informations personnelles et financières. Guide complet sur la sécurité en ligne.',
      date: '20.11.2025',
      slug: 'securite-protection-donnees-sites-paris',
      image: '/images/lucas-davies-aG6ByqGXiXg-unsplash.webp',
    },
    {
      id: 8,
      title: 'Les paris combinés : comment maximiser vos gains',
      excerpt: 'Les paris combinés offrent des gains potentiels élevés mais nécessitent une stratégie réfléchie. Découvrez comment les optimiser.',
      date: '18.11.2025',
      slug: 'paris-combines-maximiser-gains',
      image: '/images/matthias-david-eE4hMhVmS1M-unsplash.webp',
    },
    {
      id: 9,
      title: 'Application mobile vs site web : quelle option choisir ?',
      excerpt: 'Comparaison détaillée entre les applications mobiles et les sites web pour parier. Avantages, inconvénients et recommandations.',
      date: '15.11.2025',
      slug: 'application-mobile-vs-site-web',
      image: '/images/richard-bagan-SmQ2Cku3alc-unsplash.webp',
    },
  ];

  return (
    <div className="min-h-screen bg-black">
      <Disclaimer />
      <Header />
      <div className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <Link
            to="/"
            data-discover="true"
            className="inline-flex items-center gap-2 text-toxic-green hover:text-toxic-cyan mb-8 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>

          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 mb-4 px-4 py-2 glass rounded-full border border-toxic-pink/30">
              <Newspaper className="w-5 h-5 text-toxic-pink" />
              <span className="text-sm text-toxic-pink font-semibold">Actualités</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              <span className="bg-gradient-to-r from-toxic-pink to-toxic-orange bg-clip-text text-transparent">
                Actualités des paris en ligne
              </span>
            </h1>
            <p className="text-xl text-white/70 max-w-3xl mx-auto">
              Restez informé des dernières tendances, opportunités et évolutions du marché des paris sportifs en France
            </p>
          </div>

          {/* News grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
            {news.map((item) => (
              <Link
                key={item.id}
                to={`/news/${item.slug}`}
                data-discover="true"
                className="glass-strong rounded-xl overflow-hidden border border-white/10 hover:border-toxic-pink/50 transition-all hover:scale-105 group"
              >
                <div className="relative h-48 bg-gradient-to-br from-purple-900/30 to-pink-900/30 overflow-hidden">
                  <div 
                    className="absolute inset-0 bg-cover bg-center opacity-30"
                    style={{ backgroundImage: `url(${item.image})` }}
                  ></div>
                  <div className="absolute top-4 left-4 px-3 py-1 glass rounded-full border border-toxic-pink/30">
                    <span className="text-xs text-toxic-pink font-semibold">Actualité</span>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="flex items-center gap-2 text-sm text-white/60 mb-3">
                    <Calendar className="w-4 h-4" />
                    <span>{item.date}</span>
                  </div>
                  
                  <h3 className="text-xl font-bold text-white mb-3 group-hover:text-toxic-pink transition-colors">
                    {item.title}
                  </h3>
                  
                  <p className="text-white/70 text-sm leading-relaxed mb-4">
                    {item.excerpt}
                  </p>
                  
                  <div className="inline-flex items-center gap-2 text-toxic-pink hover:text-toxic-orange font-semibold text-sm transition-colors group">
                    Lire la suite
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* How we choose news section */}
          <div className="glass-strong rounded-2xl p-8 md:p-12 border border-toxic-pink/30">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 glass rounded-lg flex items-center justify-center">
                <Filter className="w-6 h-6 text-toxic-pink" />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white">
                Comment nous choisissons nos actualités
              </h2>
            </div>
            
            <div className="space-y-6 text-white/80 leading-relaxed">
              <p>
                Chez Rouge Bets, nous comprenons que l'information est la clé du succès dans les paris sportifs. C'est pourquoi nous 
                sélectionnons méticuleusement chaque actualité que nous publions, en nous assurant qu'elle apporte une valeur réelle à 
                nos lecteurs. Notre processus de sélection est rigoureux et basé sur plusieurs critères essentiels qui garantissent la 
                pertinence, la précision et l'utilité de chaque article.
              </p>
              
              <p>
                Tout d'abord, nous privilégions les informations qui ont un impact direct sur votre expérience de paris. Les nouvelles 
                concernant les bonus et promotions sont essentielles car elles peuvent considérablement augmenter votre bankroll. Les 
                analyses comparatives des cotes vous aident à identifier les meilleures opportunités. Les guides stratégiques vous 
                donnent les outils nécessaires pour améliorer vos résultats. Chaque actualité doit répondre à une question concrète ou 
                résoudre un problème réel que vous pourriez rencontrer.
              </p>
              
              <p>
                La fiabilité de nos sources est primordiale. Nous ne publions que des informations vérifiées provenant de sources 
                officielles : communiqués de l'ANJ, annonces des opérateurs agréés, données statistiques vérifiables. Nous évitons les 
                rumeurs, les spéculations non fondées, et les informations provenant de sources non vérifiées. Cette rigueur garantit 
                que vous pouvez vous fier à ce que vous lisez pour prendre des décisions éclairées concernant vos paris.
              </p>
              
              <p>
                L'actualité et la pertinence temporelle sont également cruciales. Nous privilégions les informations récentes qui 
                affectent le marché actuel. Une nouvelle promotion qui expire dans quelques jours est plus pertinente qu'une promotion 
                qui a expiré il y a plusieurs semaines. De même, une analyse des tendances récentes du marché est plus utile qu'une 
                analyse de données anciennes. Nous mettons régulièrement à jour nos articles pour refléter les évolutions du marché et 
                retirons les informations obsolètes.
              </p>
              
              <p>
                Nous nous concentrons également sur les sujets qui vous aident à maximiser vos gains et à optimiser votre expérience. 
                Les comparaisons entre opérateurs vous permettent de choisir le meilleur site pour vos besoins. Les analyses de tendances 
                vous aident à identifier les opportunités émergentes. Les guides pratiques vous donnent les compétences nécessaires pour 
                réussir. Chaque actualité doit contribuer à votre succès en tant que parieur, que ce soit en vous informant sur les 
                meilleures offres, en vous enseignant de nouvelles stratégies, ou en vous alertant sur les évolutions importantes du marché.
              </p>
              
              <p>
                La diversité des sujets est importante pour couvrir tous les aspects des paris sportifs. Nous couvrons les actualités 
                réglementaires pour vous tenir informé des évolutions légales qui pourraient affecter votre pratique. Nous analysons 
                les tendances du marché pour identifier les opportunités émergentes. Nous explorons les différentes stratégies et 
                techniques pour vous aider à améliorer vos résultats. Cette diversité garantit que vous trouvez toujours des informations 
                pertinentes, quel que soit votre niveau d'expérience ou vos préférences de paris.
              </p>
              
              <p>
                Enfin, nous privilégions toujours l'objectivité et la transparence. Nous ne favorisons aucun opérateur particulier et 
                présentons les informations de manière équilibrée. Si une nouvelle promotion présente des avantages, nous les mentionnons. 
                Si elle comporte des limitations importantes, nous les signalons également. Cette approche honnête garantit que vous recevez 
                une information complète sur laquelle vous pouvez vous appuyer pour prendre des décisions éclairées.
              </p>
              
              <p>
                Notre objectif est de vous fournir les informations les plus utiles, les plus précises et les plus pertinentes pour 
                réussir dans vos paris sportifs. Chaque actualité que nous publions passe par ce processus de sélection rigoureux, 
                garantissant que vous recevez toujours une valeur réelle lorsque vous consultez nos articles. Nous sommes votre source 
                de confiance pour rester informé et prendre de l'avance dans l'univers des paris sportifs en ligne en France.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NewsPage;

